import React, { useState, Fragment } from 'react'
import SmartEntityProvider, { useSmartEntity } from 'contexts/smart-entity'
import { useDragHandle } from 'hooks/drag-handle'
import { Layout } from '../s'
import Content from './content'
import ResizeHandle from 'components/resize-handle'
import Details from './details'

const PreviewSmartDocument = ({ slim = false, ...props }) => {
    const { layout, resizeHandle, contentHeight, handleMouseDown } = useDragHandle()

    const [includeLogo, setIncludeLogo] = useState(true)

    return (
        <Layout
            style={{ '--content-height': `${contentHeight}%` }}
            className="smart-document"
            ref={layout}>
            <Content
                {...props}
                includeLogo={includeLogo} />
            <ResizeHandle
                onMouseDown={handleMouseDown}
                ref={resizeHandle} />
            <Details
                {...props}
                includeLogo={includeLogo}
                setIncludeLogo={setIncludeLogo}
                slim={slim} />
        </Layout>
    )
}

export default ({ id, dokument, ...props }) => {
    const alreadyProvided = useSmartEntity()

    const [SmartEntityWrapper, smartEntityWrapperProps = null] = alreadyProvided ?
        [Fragment] :
        [SmartEntityProvider, {
            id,
            context: 'document',
            mode: 'fill'
        }]

    return (
        <SmartEntityWrapper {...smartEntityWrapperProps}>
            <PreviewSmartDocument
                {...props}
                listDokument={dokument} />
        </SmartEntityWrapper>
    )
}